import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reviewinvoice',
  templateUrl: './reviewinvoice.component.html',
  styleUrls: ['./reviewinvoice.component.scss']
})
export class ReviewinvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
